<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="wrapper" ref="scroll">
    <div class="messageShow" v-show="isShow">
      <span>{{ showMessage }}</span>
    </div>
    <div class="content">
      <div class="title"><span class="my">我的留言</span></div>
      <div><span class="write" @click="openLiuyan">写留言</span></div>
      <div class="return" @click="returnHome"></div>
      <div class="clean"></div>
      <div class="main">
        <div v-if="data.length > 0">
          <div class="detail" v-for="item in data">
            <div class="wenan">
              {{ item.content }}
            </div>
            <div class="time">{{ item.createTime }}</div>
          </div>
        </div>
        <div class="nomessage" v-else>暂无留言数据</div>
      </div>
    </div>
    <el-dialog
      :visible.sync="liuyanDialogVisible"
      :show-close="false"
      top="0"
      custom-class="dialog-common"
      center
    >
      <div class="liuyantext" style="margin: 0 10px">
        <el-input
          type="textarea"
          :rows="8"
          placeholder="请输入留言内容"
          v-model="textarea"
          maxlength="200"
          :show-word-limit = true
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="liuyanDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm()" :disabled="isSure" v-preventReClick>确 定</el-button>
      </span>
      <!-- <div class="footer">
        <p class="cancel" @click="showPositionDialogVisible = false">取 消</p>
        <a @click="setLocationModelData()"><p class="call">确 定</p></a>
        <div class="clear"></div>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { leaveMessage, pageLeaveMessage } from "@/api/studentCard.js";
import preventReClick from "@/utils/perventReClick.js"; 

export default {
  data() {
    return {
      liuyanDialogVisible: false,
      textarea: "",
      accessToken: "",
      studentId: "",
      imei: "",
      data: {},
      isShow: false,
      showMessage: "",
      isSure:false,
    };
  },
  mounted() {
    this.initParam();
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        Authorization: this.accessToken,
        card: this.imei,
        pageNo: 1,
        pageSize: 100,
      };
      pageLeaveMessage(params).then((res) => {
        if (res.status == 200) {
          if (res.content.result.length > 0) {
            this.data = res.content.result;
          }
        }
      });
    },
    initParam() {
      let urlParam = this.$route.query;
      this.accessToken = urlParam.accessToken;
      this.studentId = urlParam.studentId;
      this.imei = urlParam.imei;
    },
    confirm() {
      this.isSure =true
      if(this.textarea == ''){
        this.isShow = true;
          this.showMessage = "留言内容不能为空";
          setTimeout(() => {
            this.isShow = false;
            this.showMessage = "";
          }, 3000);
        this.isSure =false
        return 
      }
      let params = {
        Authorization: this.accessToken,
        card: this.imei,
        type: 11,
        noticeContent: this.textarea,
      };
      leaveMessage(params).then((res) => {
        if (res.status == 200) {
          this.liuyanDialogVisible = false;
          this.isShow = true;
          this.showMessage = "操作成功";
          setTimeout(() => {
            this.isShow = false;
            this.showMessage = "";
          }, 3000);
          this.getData();
        }
      });
      this.isSure = false
    },
    openLiuyan() {
      this.liuyanDialogVisible = true;
      this.textarea = "";
    },
    cancelLiuyan() {
      this.liuyanDialogVisible = false;
    },
    returnHome() {
      this.$router.push({
        path:
          "/studentCard/homePage?accessToken=" +
          this.accessToken +
          "&studentId=" +
          this.studentId +
          "&imei=" +
          this.imei,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .dialog-common {
  width: 100%;
  //   border-radius: 10px;
  height: 5.8rem;
  margin-top: 0rem;
}

/deep/ .dialog-common p {
  font-size: 0.4rem;
  text-align: center;
  font-family: "苹方-简 常规体";
  margin: 0 auto 0.2rem;
  color: #000000;
}

/deep/ .el-dialog--center .el-dialog__body {
  padding: 0;
}

/deep/ .footer {
  font-size: 0.34rem;
  width: 100%;
  bottom: 1px;
  height: 0.86rem;
  position: absolute;
  .cancel {
    padding: auto 50px 20px;
    color: #333333;
    float: left;
    width: 50%;
    text-align: center;
    line-height: 0.86rem;
    border-right: 1px solid #dbd6d6;
    border-top: 1px solid #dbd6d6;
  }
  .call {
    color: #2ad0b5;
    float: left;
    width: 50%;
    line-height: 0.86rem;

    text-align: center;
    border-top: 1px solid #dbd6d6;
  }
  .clear {
    content: "";
    display: block;
    clear: both;
  }
}

.wrapper {
  background-color: #f5f5f5;
  width: 100%;
  position: absolute;
  top: 0rem;
  bottom: auto;
  .messageShow {
    height: 0.5rem;
    background-color: #000000;
    opacity: 0.6;
    color: #fff;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    line-height: 0.5rem;
    z-index: 9999;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    border-radius: 3px;
    span {
      margin: 8px;
    }
  }
  .content {
    padding: 0 0.2rem;
    // background-color: red;
    .title {
      height: 1.14rem;
      width: 100%;
      line-height: 1.14rem;
      text-align: center;
      .my {
        font-size: 0.36rem;
        color: #222222;
        font-family: "苹方-简 中黑体";
        font-weight: bolder;
      }
    }
    .write {
      float: right;
      color: #2ad0b5;
      font-size: 0.32rem;
      margin-top: -0.78rem;
      font-family: "苹方-简 常规体";
    }
    .return {
      position: relative;
      left: 0.2rem;
      top: -0.78rem;
      content: "";
      display: inline-block;
      height: 16px;
      width: 16px;
      border-width: 0 0 2px 2px;
      border-color: #222;
      border-style: solid;
      transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
      -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    }
    .clean {
      content: "";
      display: block;
      clear: both;
    }
    .main {
      margin-top: -0.38rem;
      position: relative;
      .nomessage {
        width: 100%;
        text-align: center;
        margin-top: 40%;
        position: absolute;
        font-size: 0.36rem;
        // top: 100%;
      }
      .detail {
        background-color: #fff;
        border-radius: 10px;
        margin-bottom: 20px;
        padding: 10px;
        .wenan {
          font-size: 0.3rem;
          margin-bottom: 0.4rem;
          white-space: normal;
          word-break: break-all;
          overflow: hidden;
          font-family: "苹方-简 常规体";
          color: #222;
        }
        .time {
          font-size: 0.28rem;
          color: #999999;
        }
      }
    }
  }
  .loadingBox {
    padding: 20px;
    text-align: center;
  }
}
</style>